import { Component, computed, inject, input, output, ViewContainerRef } from '@angular/core';
import { PriceCurveEntry } from '../../../../core/clients/omni-core/models';
import { TranslocoService } from '@jsverse/transloco';
import { getLineConfig } from '../../chart-config/price/line.chart-config';
import { ChartComponent, LoadingSpinner } from 'excellence-ui';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { PriceFilter } from '../../stores/price.store';
import { PriceConversionService } from '../../services/price-conversion.service';

@Component({
  selector: 'app-analysis-price-graph-chart',
  templateUrl: './analysis-price-graph-chart.html',
  imports: [LoadingSpinner, ErrorComponent, ChartComponent],
})
export class AnalysisPriceGraphChart {
  private vcr = inject(ViewContainerRef);
  private translocoService = inject(TranslocoService);
  private priceConversionService = inject(PriceConversionService);

  prices = input.required<PriceCurveEntry[]>();
  comparisonPrices = input<PriceCurveEntry[] | null>(null);
  comparisonYear = input<string | number | null>(null);
  granularity = input.required<PriceFilter['granularity']>();
  showEurMwh = input.required<boolean>();
  loading = input.required<boolean>();
  error = input.required<unknown>();

  clickReload = output();

  protected graphOptions = computed(() =>
    getLineConfig(
      {
        vcr: this.vcr,
        translocoService: this.translocoService,
        priceConversionService: this.priceConversionService,
      },
      this.prices(),
      {
        granularity: this.granularity(),
        showEurMwh: this.showEurMwh(),
        comparisonData: this.comparisonPrices(),
        comparisonYear: this.comparisonYear(),
      },
    ),
  );
}
